import { render, staticRenderFns } from "./bulkUploadFile.vue?vue&type=template&id=4058a22f&"
import script from "./bulkUploadFile.vue?vue&type=script&lang=js&"
export * from "./bulkUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./bulkUploadFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports